import React from "react";
import { createMuiTheme, Divider, FormControlLabel, Paper, Switch, ThemeProvider } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import withIntl from "../../utils/withIntl";
import EditSelect from "../EditArticle/EditSelect";
import { updatePos } from "./PosApi";
import Typography from "@material-ui/core/Typography";
import cloudStore from "../../store/CloudStore";
import PhonelinkIcon from "@material-ui/icons/Phonelink";
import TextFieldForms from "../Forms/TextFieldForms";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  createPosPaperContainer: { padding: 10, width: 700 },
  labelError: { color: theme.palette.error.main },
});

function CreatePos(props) {
  const classes = useStyles();
  const [selectedPosType, setSelectedPosType] = React.useState(null);
  const allPosFields = {
    IKENTOO: {
      email: {
        value: "",
        validation: null,
        helperText: props.intl.formatMessage({ id: "email_format_required" }),
        type: "email",
      },
      locale: {
        value: "",
        validation: "[A-Za-z]{1,3}",
        type: "text",
        helperText: props.intl.formatMessage({ id: "max_3_char_only_letters" }),
      },
    },
    GASTROFIX: {
      ext_gastrofix_id: {
        value: "",
        validation: null,
        type: "number",
      },
      article_api_version: {
        value: "",
        validation: null,
        type: "number",
      },
      token: {
        value: "",
        validation: "[A-Za-z0-9]{1,40}",
        type: "text",
        helperText: "max. 40 chars.",
      },
      locale: {
        value: "",
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: props.intl.formatMessage({ id: "max_3_char_only_letters" }),
      },
    },
    MPLUS: {},
    UNTILL: {},
    TAURUS: {
      name: { value: "", required: true },
      host: { value: "", placeholder: "http://185.83.15.64", validation: null, type: "text", required: true },
      port: { value: "", validation: null, placeholder: 80, type: "number", required: true },
      pathsuffix: { value: "/easy4uas_web/awws/Easy4uAS.awws?WSDL", validation: null, type: "text", required: true },
      seconds_menu_sync: { value: "0", validation: null, type: "number", required: true },
      receipt_sync_time: { value: "120", validation: null, placeholder: 80, type: "number", required: true },
      advanced_tables: { value: false, validation: null, type: "boolean", required: true },
      betaalwijze: { value: "0", validation: null, type: "number", required: true },
    },
    LIGHTSPEED: {
      email: {
        value: "",
        validation: null,
        helperText: props.intl.formatMessage({ id: "email_format_required" }),
        type: "email",
      },
      locale: {
        value: "",
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: props.intl.formatMessage({ id: "max_3_char_only_letters" }),
      },
    },
  };
  const [selectedPosValues, setSelectedPosValues] = React.useState(null);

  const handleCreatePos = () => {
    let newPos = {};
    Object.keys(selectedPosValues).forEach((key) => {
      newPos[key] = selectedPosValues[key].value;
    });
    updatePos(newPos, selectedPosType, { merchant_id: cloudStore.merchant.id });
  };

  const switchFields = selectedPosValues
    ? Object.keys(selectedPosValues).filter((field) => selectedPosValues[field].type === "boolean")
    : [];

  const textFields = selectedPosValues
    ? Object.keys(selectedPosValues).filter(
        (field) =>
          selectedPosValues[field].type === "text" ||
          selectedPosValues[field].type === "email" ||
          selectedPosValues[field].type === "number"
      )
    : [];

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Paper classes={{ root: classes.createPosPaperContainer }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <PhonelinkIcon fontSize={"large"} />
            <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
              {props.intl.formatMessage({ id: "create_pos" })}
            </Typography>
            <Divider style={{ marginTop: "4px", marginBottom: "4px" }} />
          </div>
          <EditSelect
            value={selectedPosType == null ? "" : selectedPosType}
            optionValues={Object.keys(allPosFields)}
            optionViewValues={Object.keys(allPosFields)}
            onChange={(value) => {
              setSelectedPosValues({ ...allPosFields[value] });
              setSelectedPosType(value);
            }}
          />
          <form
            key={selectedPosValues}
            onSubmit={(e) => {
              e.preventDefault();
              handleCreatePos();
            }}
          >
            {selectedPosType &&
              textFields.map((field, index) => {
                return (
                  <TextFieldForms
                    label={field + "*"}
                    key={field}
                    required={selectedPosValues[field].required ? selectedPosValues[field].required : false}
                    placeholder={selectedPosValues[field].placeholder && selectedPosValues[field].placeholder}
                    type={selectedPosValues[field].type}
                    helperTextLabel={selectedPosValues[field].helperText ? selectedPosValues[field].helperText : null}
                    error={selectedPosValues[field].value !== allPosFields[selectedPosType][field].value}
                    inputProps={{ required: true, pattern: selectedPosValues[field].validation }}
                    value={selectedPosValues[field].value}
                    onChange={(e) => {
                      let newPos = { ...selectedPosValues };
                      newPos[field].value = e.target.value;
                      setSelectedPosValues(newPos);
                    }}
                  />
                );
              })}
            {switchFields.map((field, index) => {
              return (
                <FormControlLabel
                  control={
                    <Switch
                      checked={selectedPosValues[field].value}
                      onChange={(e) => {
                        let newActive = { ...selectedPosValues };
                        if (selectedPosValues[field].value === 1) {
                          newActive[field].value = 0;
                        } else {
                          newActive[field].value = 1;
                        }
                        setSelectedPosValues(newActive);
                      }}
                      color="primary"
                    />
                  }
                  label={field}
                  classes={
                    selectedPosValues[field].value !== allPosFields[selectedPosType][field].value && {
                      label: classes.labelError,
                    }
                  }
                />
              );
            })}
            {selectedPosType && (
              <div style={{ height: 30 }}>
                <Button type="submit" style={{ marginRight: 5, marginTop: 5, float: "right" }}>
                  {props.intl.formatMessage({ id: "save_pos" })}
                </Button>
              </div>
            )}
          </form>
        </Paper>
      </div>
    </ThemeProvider>
  );
}

export default withIntl(CreatePos);
